<div class="fz-dialog__close" mat-dialog-title>
  <button mat-icon-button (click)="handleClose()">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="fz-dialog">
  <div class="fz-dialog__root">
    <div class="fz-dialog__content">
      <div class="fz-dialog__content__picture">
        <picture>
          <img
            src="/shared/svg/wallet/payment-processor-error.svg"
            height="157"
            alt="Sorry, we couldn't verify your personal info"
          />
        </picture>
      </div>
      <h2 class="fz-dialog__content__title">
        {{ title }}
      </h2>
      <p class="fz-dialog__content__subtitle" [innerHTML]="content"></p>
    </div>

    <div class="fz-dialog__actions">
      <ng-container
        [ngTemplateOutlet]="
          remainAttempts && remainAttempts >= 1 ? options : maxAttemptsOptions
        "
      ></ng-container>
    </div>
  </div>
</div>

<ng-template #options>
  <button
    mat-flat-button
    color="primary"
    class="fz-button--medium"
    [matDialogClose]="{ signal: allowedOptions.editPersonalInfo }"
  >
    Edit personal info
  </button>
  <button
    mat-stroked-button
    color="primary"
    class="fz-button--medium"
    [matDialogClose]="{ signal: allowedOptions.tryAnotherMethod }"
  >
    Try another method
  </button>
</ng-template>

<ng-template #maxAttemptsOptions>
  <div class="action_options">
    <div>
      <mat-radio-group
        aria-labelledby="Selct one of the following options"
        class="radio-button-group"
        [(ngModel)]="selectedOption"
      >
        <mat-radio-button
          class="radio-button-group__option"
          color="primary"
          [value]="allowedOptions.registerCreditCard"
          [disabled]="isDisabledCreditCardOptions"
        >
          <div class="radio-button-group__option__root">
            <div class="radio-button-group__option__content">
              <span class="radio-button-group__option__content__title"
                >Register a Credit Card</span
              >
              <span class="radio-button-group__option__content__subtitle"
                >Your Credit Card will <b>NOT</b> be Charged.</span
              >
            </div>
            <div class="radio-button-group__option__end_adornment">
              <mat-icon>credit_card</mat-icon>
            </div>
          </div>
        </mat-radio-button>
        <mat-radio-button
          class="radio-button-group__option"
          color="primary"
          [value]="allowedOptions.uploadPicture"
          [disabled]="isDisabledUploadOptions"
        >
          <div class="radio-button-group__option__root">
            <div class="radio-button-group__option__content">
              <span class="radio-button-group__option__content__title">
                Upload ID Picture
              </span>
              <span class="radio-button-group__option__content__subtitle">
                It might take up to 48 hours (JPG, PNG, up to 20MB)
              </span>
            </div>
            <div class="radio-button-group__option__end_adornment">
              <mat-icon>photo</mat-icon>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <div class="action_options__submit">
      <button
        mat-flat-button
        color="primary"
        class="fz-button--medium"
        [disabled]="isDisabledCreditCardOptions && isDisabledUploadOptions"
        (click)="handleSelection()"
      >
        Complete Verification
      </button>
    </div>
  </div>
</ng-template>
